import { styled, useTheme } from '@mui/material'
import { Typography } from 'ComponentLibrary'
import { MonetaryValue, MonetaryValueDataObjectType } from 'ComponentLibrary'
import { CellText } from 'ComponentLibrary/src/molecules/CalculationTable/CellText'

type TotalRowProps = {
    total: { label: string; value: MonetaryValueDataObjectType }
    fontWeight?: number
    variant?: 'bodyTextLarge' | 'bodyTextSmall'
}

export default function TotalRow({ total, fontWeight = 700, variant = 'bodyTextLarge' }: TotalRowProps) {
    const theme = useTheme()
    return (
        <TableRow>
            <TableCell align="left" style={{ paddingLeft: 10 }}>
                <CellText>{total.label}</CellText>
            </TableCell>
            <TableCell align="right" style={{ paddingRight: 10 }}>
                <Typography variant={variant} color={theme.palette.customtext.black100} style={{ fontWeight }}>
                    {MonetaryValue.fromMonetaryValueDataObject(total.value).format()}
                </Typography>
            </TableCell>
        </TableRow>
    )
}

const TableRow = styled('tr')<{ borderSize?: string }>(({ theme, borderSize }) => ({
    height: '30px',
    backgroundColor: theme.palette.white,
    borderBottom: borderSize ? `${borderSize} solid ${theme.palette.green.green50};` : 'none',
}))

const TableCell = styled('td')<{ align: 'left' | 'right' }>(({ theme, align }) => ({
    ...theme.typography.bodyTextSmall,
    color: theme.palette.customtext.black54,
    textAlign: align,
    paddingTop: theme.spacing(4),
}))
